import type React from 'react';
import { SOURCE_DESCRIPTORS } from '../data/source-descriptors.ts';
import { SourceRow } from './SourceRow.tsx';

type Props = {
  onCollected: () => void;
};

/**
 * データソース一覧。Phase 1 は静的リスト + 各収集ボタン。
 * 仕様: knowledge/products/trendscope/specs/ui-layout.md §1
 */
export const SourceList = ({ onCollected }: Props): React.JSX.Element => (
  <section style={sectionStyle}>
    <h2 style={headStyle}>データソース</h2>
    <ul style={listStyle}>
      {SOURCE_DESCRIPTORS.map((s) => (
        <SourceRow key={s.name} source={s} onCollected={onCollected} />
      ))}
    </ul>
  </section>
);

const sectionStyle: React.CSSProperties = {
  width: '100%',
  marginBottom: 32,
  border: '1px solid #e0e0e0',
  borderRadius: 6,
  background: '#fff',
};

const headStyle: React.CSSProperties = {
  margin: 0,
  padding: '12px 16px',
  fontSize: 16,
  borderBottom: '1px solid #eee',
  background: '#f7f7f7',
};

const listStyle: React.CSSProperties = {
  margin: 0,
  padding: 0,
};
